module.exports = __webpack_public_path__ + "static/whoAndWhatDoTheyTeach-ba80466803d4817bd5dc488906ad0a17.png";